import html2canvas from "html2canvas";

export const CopyGraphToClipBoard = async (element: HTMLElement | SVGSVGElement | any) => {
    try {
        let canvas: HTMLCanvasElement;
        canvas = await html2canvas(element, {
            backgroundColor: null,
            scale: 2,
        });
        // Convert the canvas to a Blob
        const blob = await new Promise<Blob | null>((resolve) =>
            canvas.toBlob(resolve, "image/png")
        );
        if (!blob) throw new Error("Failed to create Blob from canvas");

        // Copy the Blob to the clipboard
        const clipboardItem = new ClipboardItem({ [blob.type]: blob });
        await navigator.clipboard.write([clipboardItem]);

        console.log("Graph copied to clipboard!");
    } catch (error) {
        console.error("Failed to copy graph to clipboard:", error);
        console.log("Failed to copy graph to clipboard.");
    }
};

export const copyText = (message: string | undefined) => {
    // Copy the message to clipboard
    if (message) {
        navigator.clipboard.writeText(message)
            .then(() => {
                console.log('Message copied to clipboard!');
            })
            .catch((err) => {
                console.error('Error copying text: ', err);
            });
    }
}